import PublicationDirector from './PublicationDirector';

export default PublicationDirector;
